import { NgClass } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'

@Component({
  selector: 'candidate-protection-icon',
  standalone: true,
  imports: [E11TooltipModule, NgClass],
  template: `
    <e11-tooltip [color]="'dark'" [tooltipText]="tooltipText">
      <span
        (click)="onClick.emit()"
        class="material-symbols-outlined e11-text-base e11-cursor-pointer"
        [ngClass]="{
          'e11-text-skin-primary-accent': isActive,
          'e11-text-skin-grey hover:e11-text-skin-primary': !isActive
        }"
      >
        shield_person
      </span>
    </e11-tooltip>
  `,
})
export class CandidateProtectionIcon {
  @Input() tooltipText?: string
  @Input() isActive?: boolean

  @Output() onClick = new EventEmitter()
}
